import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SignatureComponent } from '../views/signature/signature.component';
import { QrcodeScannerComponent } from '../views/qrcode-scanner/qrcode-scanner.component';
import { AppComponent } from '../app.component';
export const routes: Routes = [
  {
    path:'',
    component: QrcodeScannerComponent
  },
  {
    path: 'signature',
    component: SignatureComponent,
    data: {
      title: 'Sign Page'
    }
  },
  {
    path: 'qrcode',
    component: QrcodeScannerComponent,
    data: {
      title: 'Qrcode'
    }
  }
]


@NgModule({
  imports: [ RouterModule.forRoot(routes,{})],
  exports: [ RouterModule ]
}
)
export class RoutingModule { }
